<!--
  SupportMarkdown.svelte — a support message body, rendered from Markdown.

  The HTML comes from `renderSupportMarkdown`, which escapes raw HTML, vets
  every link and runs the result through the `sanitizeHTML` allow-list, so it is
  safe for `{@html}`. `markdown` restores the list, heading and code styling
  Tailwind's preflight strips; `break-words` keeps a long URL or log line from
  widening the thread past its column.
-->
<script lang="ts">
	import { renderSupportMarkdown } from '../support/markdown';

	interface Props {
		/** The message as written. */
		text: string;
		/** Extra classes for the wrapper. */
		class?: string;
	}

	let { text, class: className = '' }: Props = $props();

	/** The rendered, sanitized body. */
	let html = $derived(renderSupportMarkdown(text));
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -- sanitized by renderSupportMarkdown -->
<div class="markdown support-markdown break-words {className}">{@html html}</div>
